import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import LanguageDropDown from "../dynamic/LanguageDropDown";
import { SaveButton } from "../buttons/Buttons";
import { BsInfoCircleFill } from "react-icons/bs";

const WEBSITE_URL = "/website";

export default function MetaTagsForm() {
  const { username } = useAuth();
  const { i18n, t } = useTranslation();

  const [art, setArt] = useState(i18n.language);
  const [metaTitle, setMetaTitle] = useState(null);
  const [metaDescription, setMetaDescription] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    setArt(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const [titleRes, descriptionRes] = await Promise.all([
          axios.get(WEBSITE_URL, {
            params: { username, art, title: "metaTitle" },
          }),
          axios.get(WEBSITE_URL, {
            params: { username, art, title: "metaDescription" },
          }),
        ]);

        const fetchedTitle = titleRes?.data?.entry?.content;
        const fetchedDescription = descriptionRes?.data?.entry?.content;
        setMetaTitle((fetchedTitle && fetchedTitle !== 'default text') ? fetchedTitle : null);
        setMetaDescription((fetchedDescription && fetchedDescription !== 'default text') ? fetchedDescription : null);
      } catch (err) {
        console.log(err);
      }
    };

    fetchMeta();
  }, [username, art]);

  const saveMeta = async () => {
    try {
      const titleContent = (metaTitle || "").trim();
      const descriptionContent = (metaDescription || "").trim();

      await Promise.all([
        axios.put(WEBSITE_URL, {
          username,
          art,
          title: "metaTitle",
          content: titleContent || null,
        }),
        axios.put(WEBSITE_URL, {
          username,
          art,
          title: "metaDescription",
          content: descriptionContent || null,
        }),
      ]);

      setIsSubmitted(true);
      setTimeout(() => setIsSubmitted(false), 2500);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSaveClick = (event) => {
    event.preventDefault();
    saveMeta();
  };

  return (
    <div>
      <form className="review-form meta-form">
        <h3>{t("dashboard_page.meta_form.title")}</h3>

        <div className="form-row">
          <div className="meta-label-wrap">
            <label className="form-label" htmlFor="metaTitle">
              {t("dashboard_page.meta_form.metaTitle")}
            </label>
            <span
              className="meta-info-icon tooltip-label"
              data-tooltip={t("dashboard_page.meta_form.metaTitleHelp")}
              title={t("dashboard_page.meta_form.metaTitleHelp")}
              aria-label={t("dashboard_page.meta_form.metaTitleHelp")}
            >
              <BsInfoCircleFill />
            </span>
          </div>
          <textarea
            id="metaTitle"
            value={metaTitle || ""}
            onChange={(event) => setMetaTitle(event.target.value)}
            className="dashboard-textarea"
            rows={3}
          />
        </div>

        <div className="form-row">
          <div className="meta-label-wrap">
            <label className="form-label" htmlFor="metaDescription">
              {t("dashboard_page.meta_form.metaDescription")}
            </label>
            <span
              className="meta-info-icon tooltip-label"
              data-tooltip={t("dashboard_page.meta_form.metaDescriptionHelp")}
              title={t("dashboard_page.meta_form.metaDescriptionHelp")}
              aria-label={t("dashboard_page.meta_form.metaDescriptionHelp")}
            >
              <BsInfoCircleFill />
            </span>
          </div>
          <textarea
            id="metaDescription"
            value={metaDescription || ""}
            onChange={(event) => setMetaDescription(event.target.value)}
            className="dashboard-textarea"
            rows={5}
          />
        </div>

        <div className="meta-form-actions">
          <SaveButton
            buttonText={t("button.save")}
            onClick={handleSaveClick}
            type="submit"
          />
          <div className="meta-language-wrap">
            <LanguageDropDown setArt={setArt} art={art} />
          </div>
        </div>

        {isSubmitted && (
          <p style={{ marginTop: "10px", color: "green" }}>
            {t("dashboard_page.meta_form.successmsg")}
          </p>
        )}
      </form>
    </div>
  );
}
